<div class="confirm-payment-container totem-styles">
    <!-- <div class="d-flex justify-content-between close-icon">
        <i class="fa-light fa-times pointer-in" (click)="goHome()"></i>
    </div> -->
    <!-- <p class="info-error" *ngIf="error">{{error}}</p> -->

    <div class="d-grid">
        <div class="icon-check-confirm">
            <i class="fa-light fa-circle-check"></i>
        </div>
        <!-- <div class="logo-city">
            <img fallimg src="assets/img/citylok_logo.png" alt="Citylok logo">
        </div> -->
        <!-- <p class="info-confirm">Identificador: <strong>{{hash}}</strong></p> -->
        <p class="info-confirm">¡Gracias por comprar en Citylok!</p>
        <p class="text-confirm-totem">Tus entradas se han enviado a tu {{method=='phone'?'teléfono':'correo electrónico'}}: <strong>{{methodUser}}</strong></p>

        <p class="text-confirm-totem">Además, puedes descargarlas ahora mismo escaneando este QR 👇</p>

        <div class="container-qr-code">
            <qrcode [qrdata]="hash" [allowEmptyString]="true" [cssClass]="'center'" [colorDark]="'#ff4d80'"
                [colorLight]="'#ffffffff'" [elementType]="'canvas'" [errorCorrectionLevel]="'M'" [imageHeight]="120"
                [imageWidth]="120" [margin]="4" [scale]="1" [title]="'Hash pedido'" [width]="300"></qrcode>
        </div>

        <p class="text-confirm-totem">Esta pantalla se cerrará automáticamente en <span>{{seconds.toString().length<2? '0' +seconds : seconds}}</span> segundos.</p>
        <p class="info-confirm">¿Problemas con tus entradas? Hazle una foto a este código y escríbenos a: hola@citylok.com</p>

        <button class="btn-confirm-wahtsapp pointer-in" (click)="goHome()">
            Finalizar
        </button>
    </div>
</div>